<template>
  <div class="tregister">
    <md-dialog :md-active.sync="showModal" :md-click-outside-to-close="false">
      <md-dialog-title>Documento de Identificación</md-dialog-title>

      <div class="md-layout-item">
        <md-field>
          <label for="doc">Tipo de Documento</label>
          <md-select v-model="documentType" name="doc" id="doc">
            <md-option value="01">DNI</md-option>
            <md-option value="04">CARNÉ DE EXTRANJERÍA</md-option>
            <md-option value="07">PASAPORTE</md-option>
            <md-option value="23">PTP</md-option>
          </md-select>
        </md-field>
      </div>

      <md-field>
        <label>Número de documento</label>
        <md-input v-model="documentNumber"></md-input>
      </md-field>

      <md-dialog-actions>
        <md-button class="md-accent" @click="showModal = false">Cerrar</md-button>
        <md-button class="md-primary" @click="setDocument()">Guardar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog class="modal-tregister-historic" :md-active.sync="confirmDelete">
      <md-dialog-title>Confirma la eliminación?</md-dialog-title>
      <md-dialog-content>Esta acción no se puede revertir</md-dialog-content>
      <md-dialog-actions>
        <md-button @click="confirmDelete = false">Cancelar</md-button>
        <md-button class="md-accent md-raised" @click="deleteItem">Eliminar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <div class="tregister__wrapper">
      <div class="tregister__container">
        <div class="tregister__container-close" @click="closeModal">
          <i class="icon-close"></i>
        </div>
        <div class="tregister__nav-tabs">
          <div
            class="tregister__nav-tab"
            :class="{
              'tregister__nav-tab--selected': currentComponent == 'General',
            }"
            @click="currentComponent = 'General'"
          >
            Datos Generales
          </div>
          <div
            class="tregister__nav-tab"
            :class="{
              'tregister__nav-tab--selected': currentComponent == 'DerechoHabiente',
            }"
            @click="currentComponent = 'DerechoHabiente'"
          >
            Derechohabientes
          </div>
          <div
            class="tregister__nav-tab"
            :class="{
              'tregister__nav-tab--selected': currentComponent == 'CasoEspecial',
            }"
            @click="currentComponent = 'CasoEspecial'"
          >
            Casos Especiales
          </div>
        </div>
        <keep-alive>
          <component
            :is="currentComponent"
            :isHistoric="isHistoric"
            :value="data"
            @updateData="updateData()"
            :historicId="idTregisterHistoric"
            @close-modal="$emit('close-modal')"
            :date="dateSelect"
          />
        </keep-alive>
      </div>

      <div class="tregister__nav">
        <v-date-picker
          :value="null"
          is-inline
          @update:fromPage="toMonth"
          class="only-month-tregister"
        ></v-date-picker>
        <div class="tregister__historic-wrap" v-if="tregisterHistoricList.length > 0">
          <h4>Histórico</h4>
          <div class="tregister__historic-list">
            <div
              class="tregister__historic"
              v-for="item in tregisterHistoricList"
              :key="`tregister-historic-${item.id}`"
            >
              <md-radio v-model="idTregisterHistoric" :value="item.id"
                >TRegistro - {{ item.formatDate }}</md-radio
              >
            </div>
          </div>
          <div class="tregister__historic-action">
            <!-- <md-button class="delete-color" @click="confirmDeleteAction">Delete</md-button> -->
            <md-button class="md-primary md-raised" @click="getDetail"
              >Ver Actual</md-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import EventBus from "@/eventBus";

import Laborales from "@/components/T-Register/Laborales";
import SeguridadSocial from "@/components/T-Register/SeguridadSocial";
import SituacionEducativa from "@/components/T-Register/SituacionEducativa";
import DerechoHabiente from "@/components/T-Register/DerechoHabiente";
import CasoEmergencia from "@/components/T-Register/CasoEmergencia";
import CasoEspecial from "@/components/T-Register/CasoEspecial";
import General from "@/components/T-Register/General";

export default {
  components: {
    Laborales,
    SeguridadSocial,
    SituacionEducativa,
    DerechoHabiente,
    CasoEmergencia,
    CasoEspecial,
    General,
  },
  props: {
    newUser: Boolean,
    currentData: Object,
    origin: String,
    details: Object,
  },
  async created() {
    this.showModal = this.newUser;
    console.log(this.newUser, this.currentData);
    if (!this.newUser) {
      await this.$store
        .dispatch("getTregistersHistoric", {
          id: this.$store.state.business.currentTRegister,
          query: `date=${this.dateSelect.toISOString()}`,
        })
        .then((res) => {
          if (res.status === 200) {
            if (this.tregisterHistoricList.length > 0) {
              this.showTregisterHistoric = true;
            } else {
              this.$store
                .dispatch("createTregisterHistoric", {
                  id: this.$store.state.business.currentTRegister,
                  body: {
                    date: this.dateSelect.toISOString(),
                  },
                })
                .then((res2) => {
                  if (res2.status === 200) {
                    this.$store
                      .dispatch("getTregistersHistoric", {
                        id: this.$store.state.business.currentTRegister,
                        query: `date=${this.dateSelect.toISOString()}`,
                      })
                      .then((res3) => {
                        if (res3.status === 200) {
                          this.showTregisterHistoric = true;
                        }
                      });
                  }
                });
            }
          }
        });
    }
    if (this.currentData) {
      // this.data = this.currentData
      this.data = this.details;
    }
    EventBus.$on("stateView", (val) => {
      console.log("lalala");

      console.log(val);

      this.status = val;
    });
  },
  data() {
    return {
      currentComponent: "General",
      showModal: false,
      documentType: null,
      documentNumber: null,
      //datos empleado
      data: {},
      status: null,
      dateSelect: new Date(),
      showTregisterHistoric: false,
      idTregisterHistoric: null,
      confirmDelete: false,
      isHistoric: false,
    };
  },
  computed: {
    ...mapGetters({}),
    currentComponentTitle() {
      let title = ""
      switch (this.currentComponent) {
        case "General":
          title= "Datos Generales";
          break;
        case "DerechoHabiente":
          title = "Derechohabientes";
          break;
        case "CasoEspecial":
          title = "Casos Especiales";
          break;
        default: title = "OTROS"
      }
      return title;
    },

    maxBornDate() {
      return new Date(
        new Date().getFullYear() - 18,
        new Date().getMonth(),
        new Date().getDate()
      );
    },
    tregisterHistoricList() {
      const aux =this.$store.state.business.tregisterHistoricList
      return aux.sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        if (dateA > dateB) {
          return -1;
        }
        if (dateA < dateB) {
          return 1;
        }
        return 0;
      });
    },
  },

  methods: {
    ...mapActions({
      createTRegister: "createTRegister",
      setCurrentTRegister: "setCurrentTRegister",
      updateTRegister: "updateTRegister",
      getTRegister: "getTRegister",
      getTRegisters: "getTRegisters",
    }),
    async toActual() {
      this.data = this.details;
      this.isHistoric = false;
    },
    getDetail() {
      console.log("get detail de: ", this.idTregisterHistoric);
      this.$store
        .dispatch("getTregistersHistoricDetail", {
          id: this.$store.state.business.currentTRegister,
          fk: this.idTregisterHistoric,
        })
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data);
            this.data = res.data;
            console.log(this.data);
            // this.details = res.data;
            this.isHistoric = true;
            // this.showTregisterHistoric = false;
            // this.idTregisterHistoric = null;
          }
        });
    },
    confirmDeleteAction() {
      this.showTregisterHistoric = false;
      this.confirmDelete = true;
    },
    deleteItem() {
      this.$store
        .dispatch("deleteTregistersHistoric", {
          id: this.$store.state.business.currentTRegister,
          fk: this.idTregisterHistoric,
        })
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data);
            this.$store
              .dispatch("getTregistersHistoric", {
                id: this.$store.state.business.currentTRegister,
                query: `date=${this.dateSelect.toISOString()}`,
              })
              .then((res) => {
                if (res.status === 200) {
                  this.confirmDelete = false;
                  this.idTregisterHistoric = null;
                  // if(this.tregisterHistoricList.length > 0){
                  //   this.showTregisterHistoric = true
                  // }
                }
              });
          }
        });
    },
    cancelDetail() {
      this.showTregisterHistoric = false;
      this.idTregisterHistoric = null;
    },
    toMonth(val) {
      if (val) {
        console.log("valor de val: ", val);
        console.log("tregister id: ", this.$store.state.business.currentTRegister);
        this.dateSelect = new Date(val.year, val.month, 0);
        console.log(this.dateSelect.toLocaleDateString(), this.dateSelect.toISOString());
        this.$store
          .dispatch("getTregistersHistoric", {
            id: this.$store.state.business.currentTRegister,
            query: `date=${this.dateSelect.toISOString()}`,
          })
          .then((res) => {
            if (res.status === 200) {
              if (this.tregisterHistoricList.length > 0) {
                this.showTregisterHistoric = true;
              } else {
                this.$store
                  .dispatch("createTregisterHistoric", {
                    id: this.$store.state.business.currentTRegister,
                    body: {
                      date: this.dateSelect.toISOString(),
                    },
                  })
                  .then((res2) => {
                    if (res2.status === 200) {
                      this.$store
                        .dispatch("getTregistersHistoric", {
                          id: this.$store.state.business.currentTRegister,
                          query: `date=${this.dateSelect.toISOString()}`,
                        })
                        .then((res3) => {
                          if (res3.status === 200) {
                            this.showTregisterHistoric = true;
                          }
                        });
                    }
                  });
              }
            }
          });
      }
    },
    nextForm() {
      if (this.currentComponent == "Laborales") this.currentComponent = "SeguridadSocial";
      else if (this.currentComponent == "SeguridadSocial")
        this.currentComponent = "DerechoHabiente";
    },

    setDocument() {
      this.createTRegister({
        documentType: this.documentType,
        documentNumber: this.documentNumber,
      }).then((r) => {
        console.log(r);
        EventBus.$emit("newTR");
        this.$emit("tregister-created", r.data.id);

        // this.getTRegisters(this.$localStorage.get('businessID'))
        this.getTRegisters({
          id: this.$localStorage.get("businessID"),
          state: "draft",
          page: 1,
        }).then((r) => {
          if (r.status == 200) {
            EventBus.$emit("totalPages", r.data.totalPages);
          }
        });
        // this.updateTRegister(this.data)
        this.showModal = false;
      });
    },

    updateData(payload) {
      this.data = payload;
    },
    closeModal() {
      console.log("cerrar tregister modal");
      this.getTRegisters({
        id: this.$localStorage.get("businessID"),
        state: this.origin,
        page: 1,
      }).then((r) => {
        if (r.status == 200) {
          EventBus.$emit("totalPages", r.data.totalPages);
          this.$emit("close-modal");
        }
      });
    },
  },
  watch: {
    idTregisterHistoric: function (n, o) {
      this.getDetail();
      console.count("idtregisterhistorico");
    },
    details: function () {
      this.data = { ...this.data, ...this.details };
    },
    data: function (n, o) {
      console.count("data");
      console.log(n, o);
    },
  },
};
</script>
<style lang="scss">
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}
.only-month-tregister {
  background-color: #fff !important;
  border-radius: 6px;
  border: none !important;
  justify-self: flex-start;
  align-self: center;
  order: -1;
  margin-bottom: 1.5rem;
  .c-pane {
    .c-weeks {
      display: none;
    }
    .c-weekdays {
      display: none;
    }
  }
  @include mq($md) {
    justify-self: center;
    align-self: flex-start;
    order: -1;
    margin: 1rem auto;
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS
.selected {
  .tregister__nav-circle {
    background-color: $b-orange !important;
    border: 0;
  }
  .option-title {
    color: $b-orange;
    font-weight: 600;
  }
}

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

.md-dialog {
  z-index: 900;
  padding: 1rem 3rem;
  // max-width: 768px;
}

.tregister {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 600;
  background-color: rgba(46, 54, 103, 0.75);
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    box-shadow: 0 0 2000px rgba($b-blue-dark, 0.75) inset;
    background: inherit;
  }

  &__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    @include mq($md) {
      width: 90%;
      max-width: 75rem;
      // height: 90%;
      max-height: 643px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__nav {
    height: 100%;
    width: 18rem;
    border-top-left-radius: 9px;
    border-bottom-left-radius: 9px;
    background-color: #eceff8;
    padding: 0 1rem;
    box-sizing: border-box;
    &-tabs {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 1rem 2rem 0rem;
    }
    &-tab {
      padding: 0.5rem 1rem;
      border: thin solid $b-blue;
      color: $b-blue;
      border-bottom: none;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      margin-right: 8px;
      cursor: pointer;
      transition: all 0.2s;
      &--selected {
        border: thin solid $b-emph;
        color: $b-emph;
        font-weight: bold;
      }
    }
    &-line {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      width: 100%;
      background-color: $b-blue;
      @include mq($md) {
        top: 15%;
        transform: rotate(90deg);
        transform-origin: left;
        margin-left: 3.5rem;
      }
    }

    &-close {
      position: absolute;
      right: 1rem;
      top: 1rem;
      color: $b-orange;
      font-size: 1.2rem;
      @include mq($md) {
        display: none;
      }
    }

    &-title {
      margin-top: -1rem;
      color: $b-orange;
      font-weight: 600;
      font-size: 1.1rem;
      @include mq($md) {
        display: none;
      }
    }

    &-circles {
      position: absolute;
      bottom: -1.5rem;
      left: 50%;
      width: 21rem;
      transform: translateX(-50%);
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      z-index: 3;
      @include mq($md) {
        flex-direction: column;
        top: 12%;
        left: 50%;
        bottom: unset;
        width: 100%;
        height: 20rem;
        padding-left: 2rem;
      }
    }
    &-option {
      @include mq($md) {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        cursor: pointer;
      }
    }

    &-circle {
      height: 3rem;
      width: 3rem;
      border: 1px solid $b-blue;
      background-color: #fff;
      border-radius: 100%;
      transition: all 0.3s ease-out;
    }
  }

  &__container {
    position: absolute;
    top: 8rem;
    left: 0;
    height: calc(100% - 8rem);
    width: 100%;
    background-color: #f2f2f2;
    background-color: #fff;
    padding: 2rem 0 0 0;
    overflow-y: scroll;
    scrollbar-width: none;
    z-index: 1;
    @include mq($md) {
      overflow-y: auto;
      border-top-right-radius: 9px;
      border-bottom-right-radius: 9px;
      padding: 1rem 0 0 0;
    }
    &-close {
      display: none;
      z-index: 100;
      @include mq($md) {
        display: block;
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        color: $b-blue-dark;
        font-size: 2rem;
        cursor: pointer;
      }
    }
    @include mq($md) {
      width: calc(100% - 18rem);
      left: 18rem;
      height: 100%;
      top: 0;
    }
  }
}

.option-title {
  display: none;
  @include mq($md) {
    display: block;
    font-size: 1rem;
    width: 11rem;
    margin-left: 1rem;
    line-height: 1rem;
  }
}
.modal-tregister-historic {
  padding: 1rem 2rem !important;
  width: 500px;
  .tregister__historic-wrap {
    width: 100%;
    overflow: auto;
  }
}
.tregister__historic-wrap {
  height: 70%;
  width: 100%;
  padding: 0.8rem;
  box-sizing: border-box;
  background-color: #fff;
  h4 {
    text-align: center;
    color: $b-blue;
  }
}
.tregister__historic-list {
  width: 100%;
  max-height: 350px;
  overflow: auto;
}
.tregister__historic-action {
  margin-top: 0.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
}
.delete-color {
  & /deep/ .md-ripple {
    .md-button-content {
      color: #ff5252;
    }
  }
}
</style>
